export enum ProcessStepStatus {
	Completed = "ABGESCHLOSSEN"
}

export const PERMISSON_DATAHOLDER = "taskPermission";
